// extracted by mini-css-extract-plugin
module.exports = {"message":"tableOverlay_message__2dJe2"};